const githubConfig = {
  publicLink: process.env.REACT_APP_GITHUB_PUBLIC_LINK,
};

export default githubConfig;
